import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import * as styles from './_DisabledEditProfileButton.scss'
import React from 'react';

const DisabledEditProfileButton = ({
  buttonText
  , size
  , onClick
  , isDisabled
}) => (
  <Button type='submit'
    variant={'primary'}
    size={size}
    onClick={onClick}
    className={styles['right-align'] + ' ' + styles['disabled']}
    disabled={isDisabled}>
    <span>{buttonText}</span>
  </Button>)

DisabledEditProfileButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
}

export default (DisabledEditProfileButton)
